import { useIsSSR } from 'react-aria';
import { ThresholdSlider } from './ThresholdSlider';

interface ModelSettingsProps {
  isThresholdSliderVisible: boolean;
  minThreshold: number;
  setMinThreshold: (num: number) => void;
}

export const ModelSettings = ({ isThresholdSliderVisible, minThreshold, setMinThreshold }: ModelSettingsProps): JSX.Element | null => {
  const isSSR = useIsSSR();

  return <>{!isSSR && isThresholdSliderVisible && <ThresholdSlider minThreshold={minThreshold} setMinThreshold={setMinThreshold} />}</>;
};
